import { useCallback } from 'react'

import { type CoreInsuranceStatus, type CoreInsurance } from '@flecto/types'
import {
  type FilterValue,
  type DateRange,
} from '@flecto/ui/@shared/Filters/components/multi-select/filterTypeConfig'

export function useProcessInsuranceFilters() {
  const processInsuranceFilters = useCallback(function (
    filtersApplied: FilterValue[]
  ): Record<string, unknown> {
    const filters: Record<string, unknown> = {}

    filtersApplied.forEach(({ key, value }) => {
      switch (key) {
        case 'start_at': {
          const { startDate, startTime } = value as DateRange

          filters.start_date = startDate
            ? `${startDate}T${startTime || '00:00:00'}`
            : null

          break
        }
        case 'end_at': {
          const { endDate, endTime } = value as DateRange

          filters.end_date = endDate
            ? `${endDate}T${endTime || '00:00:00'}`
            : null

          break
        }
        case 'policy-status': {
          filters.meta_status = value as CoreInsuranceStatus[]
          break
        }

        case 'policy-type': {
          filters.policy_type = value as CoreInsurance['policy_type']
          break
        }

        default:
          break
      }
    })
    return filters
  }, [])

  return { processInsuranceFilters }
}
